var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgAccountMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 5L18 2.6c-.4-.4-.9-.6-1.4-.6H5.5C4.1 2 3 3.1 3 4.5v15C3 20.9 4.1 22 5.5 22h13c1.4 0 2.5-1.1 2.5-2.5V6.4c0-.5-.2-1-.6-1.4zM19 19.5c0 .3-.2.5-.5.5h-13c-.3 0-.5-.2-.5-.5v-15c0-.3.2-.5.5-.5H16v3h3v12.5z",
    fill: "#45474A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1zM15 14H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1z",
    fill: "#45474A"
  })));
}

export default SvgAccountMenuIcon;